import { TimelineQuery } from './queries/timeline_query';
import { IQuery, ICommand } from 'core-ts-types';
import {
  ITimelineHeader,
  ITimeBlocks,
  IGroupsBlock,
  ITimeSliceTile,
  ITimelineFooter
} from '../../interfaces/scheduler_interfaces';
import { CommunicatorService } from 'ui-ng-component-communicator';
import * as _4 from 'lodash4';

class TimelineController {
  private query: IQuery;
  private headers: ITimelineHeader[];
  private footer: ITimelineFooter[];
  private timeblocks: ITimeBlocks[];
  private timeblockGroups: IGroupsBlock[];
  private timeSlices: ITimeSliceTile[];
  private timeSliceChangedBound: () => void;

  constructor(
    private ngTimelineQuery: TimelineQuery,
    private ngComponentCommunicatorService: CommunicatorService,
    private getSectionDetailsCommand: ICommand,
    private saveSelectedTimeSliceToModel: ICommand
  ) {}

  timeSliceChanged() {
    this.timeSlices = [];
  }

  subHeadingClick(event: JQueryEventObject & { detail: { srcElement: { start: string } } }) {
    this.updateSelectedTimeSlice(event.detail.srcElement.start);
  }

  updateSelectedTimeSlice(startUnix: string) {
    const timeSlice = _4.find(this.timeSlices, { startUnix });
    this.saveSelectedTimeSliceToModel(timeSlice);
  }

  openSectionDetail(timeblock: ITimeBlocks) {
    this.getSectionDetailsCommand(timeblock.section.id).then(() =>
      this.ngComponentCommunicatorService.publish('OPEN_SECTION_DETAIL_MODAL')
    );
  }
}
angular.module('capability-ng-scheduler').component('timeline', {
  templateUrl: 'capability-ng-scheduler/src/components/timeline/timeline.html',
  bindings: {
    headers: '<',
    timeblocks: '<',
    timeblockHighlight: '<',
    timeblockGroups: '<',
    timeSlices: '<',
    footer: '<'
  },
  controller: TimelineController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/timeline/timeline.ts